import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as firebase from 'firebase/app';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-section2-2',
  templateUrl: './section2-2.component.html',
  styleUrls: ['./section2-2.component.css'],
  providers: [AngularFireDatabase]
})
export class Section22Component implements OnInit {
  currentDate:any;
  datetoday:any;
  myFormMonth:FormGroup;
  totalIntransitPerYear:any;
  branchWiseShipmentsForCurrentMonth:any;
  donutChartData:any;
  type:any;
  constructor(private db:AngularFireDatabase) {
    this.currentDate = new Date();
    this.datetoday = this.currentDate.getDate()+"/"+(this.currentDate.getMonth() + 1)+"/"+this.currentDate.getFullYear();
    let month = new FormControl(this.currentDate.getMonth()+1, Validators.required);
      this.myFormMonth = new FormGroup({
        month: month
      });
  }

  ngOnInit() {
    this.type = "revenue";
    this.branchPerformanceFortheMonth(this.currentDate.getMonth()+1,3000);
  }
  monthlyBranchPerformance(event)
  {
    this.branchPerformanceFortheMonth(event.target.value,500);
  }
  branchPerformanceFortheMonth(month,time)
  {
    var year = this.currentDate.getFullYear();
    this.db.list("branches").snapshotChanges().subscribe(item=>{
      this.totalIntransitPerYear = 0;
      this.branchWiseShipmentsForCurrentMonth = [];
        item.forEach(element =>{
          firebase.database().ref("shipments").orderByChild("branch").equalTo(element.key).on("value",(snapshot)=>{
            var data = snapshot.val();
            if(data!=null)
            {
              //console.log("snapshot data",data);
                var y = element.payload.toJSON();
                var totalCash = 0;
                var totalShipment = 0;
                for(let i in data)
                {
                  var datesource = null;
                  var datedestination = null;
                  if(data[i].source.date!=null)
                  {
                    datesource = data[i].source.date;
                  }
                if(data[i].destination.date!=null)
                {
                  datedestination = data[i].destination.date;
                }
                //console.log("date",datesource,datedestination, month, year);
                  if(datesource!=null && datesource.month == month && datesource.year == year)
                  {
                  totalShipment++;
                  //console.log("totalShipment datesource",totalShipment);
                  if(data[i].cashCollected)
                  {
                    totalCash = totalCash + data[i].cashCollected;
                  }
                  }
                  else if(datedestination!=null && datedestination.month == month && datedestination.year == year) 
                  {
                    totalShipment++;
                    //console.log("totalShipment datedestination",totalShipment);
                    if(data[i].cashCollected)
                    {
                      totalCash = totalCash + data[i].cashCollected;
                    }
                  }
              }
              y["totalCash"] = totalCash;
              y["totalShipment"] = totalShipment;
              this.branchWiseShipmentsForCurrentMonth.push(y);
              //console.log("branchWiseShipmentsForCurrentMonth date today",this.branchWiseShipmentsForCurrentMonth);
            }
            else
            {
              //console.log("data.length",0);
              var y = element.payload.toJSON();
              y["totalShipment"] = 0;
              y["totalCash"] = 0;
              this.branchWiseShipmentsForCurrentMonth.push(y);
              //console.log("branchWiseShipmentsForCurrentMonth",this.branchWiseShipmentsForCurrentMonth);
            }
          });
        });
      });
      setTimeout(() => {
        this.getDonutChartData();
      }, time);
}
getDonutChartData()
  {
    var dataTable= [];
    dataTable.push(['Task', 'Hours per Day']);
    //console.log("getDonutChartData", this.branchWiseShipmentsForCurrentMonth);
    if(this.branchWiseShipmentsForCurrentMonth!=null && this.branchWiseShipmentsForCurrentMonth.length > 0)
    {
      this.branchWiseShipmentsForCurrentMonth.forEach(branch=>{
        var branchNames = [];
        if(branch.totalShipment != 0)
        {
          branchNames.push(branch.name);
          if(this.type == "sales")
          {
            branchNames.push(branch.totalShipment);
          }
          else
          {
            branchNames.push(branch.totalCash);
          }
          dataTable.push(branchNames);
        }
      });
      //console.log("dataTable", dataTable);
      setTimeout(() => {
        this.donutChartData =  {
          chartType: 'PieChart',
          dataTable: dataTable,
          options: {
            height: 320,
            title: 'Branch',
            pieHole: 0.4,
            colors: ['#d786ef', '#5d3d67', '#b5a6b9', '#5D9CEC', '#5FBEAA', '#FF552A', '#FF00AA', '#00D5D5']
          },
        };
      }, 500);
    }
  }

  branchPerformance(event)
  {
    this.type = event.target.value;
    this.getDonutChartData();
    //this.branchPerformanceFortheMonth(this.myFormMonth.value.month);
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section2-2/section2-2.component.ts